import React from 'react'
import {Popover, OverlayTrigger} from 'react-bootstrap'

const HelpPopover = ({helpText}) => {
  const popoverHoverFocus = (
      <Popover id="popover-trigger-hover-focus">
        {helpText}
      </Popover>
    )

  return(
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="top"
      overlay={popoverHoverFocus}
    >
      <span><i className="fa fa-question-circle"></i></span>
    </OverlayTrigger>
  )
}

export default HelpPopover;


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/HelpPopover.jsx